var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPadrons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68.0057,
    height: 67.1214,
    rx: 10,
    transform: "matrix(0.999916 0.0129595 0 1 0 0)",
    fill: "#E5F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5706 37.4776C35.61 37.4776 38.0739 35.0458 38.0739 32.0459C38.0739 29.0461 35.61 26.6143 32.5706 26.6143C29.5313 26.6143 27.0674 29.0461 27.0674 32.0459C27.0674 35.0458 29.5313 37.4776 32.5706 37.4776Z",
    stroke: "#009FFF",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7345 49.984C42.7345 45.4801 38.1909 41.8074 32.5701 41.8074C26.9494 41.8074 22.4058 45.4608 22.4058 49.984",
    stroke: "#009FFF",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2541 35.1002C51.2541 45.2483 42.9306 53.4635 32.6488 53.4635C22.3669 53.4635 14.0435 45.2483 14.0435 35.1002C14.0435 24.952 22.3669 16.7368 32.6488 16.7368C35.2143 16.7368 37.6624 17.2394 39.895 18.1672C39.6404 18.9404 39.5033 19.7523 39.5033 20.6028C39.5033 22.0525 39.9146 23.4249 40.6393 24.5847C41.0309 25.2419 41.5401 25.8411 42.1277 26.3437C43.4986 27.5808 45.32 28.3347 47.3372 28.3347C48.1989 28.3347 49.0214 28.1994 49.7852 27.9287C50.7253 30.1323 51.2541 32.5679 51.2541 35.1002Z",
    stroke: "#009FFF",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1705 20.6028C55.1705 21.2213 55.0922 21.8205 54.9355 22.4004C54.7593 23.1736 54.4459 23.9275 54.0346 24.5847C53.0946 26.1504 51.5866 27.3682 49.7848 27.9287C49.021 28.1994 48.1985 28.3347 47.3367 28.3347C45.3195 28.3347 43.4982 27.5808 42.1273 26.3437C41.5397 25.8411 41.0305 25.2419 40.6388 24.5847C39.9142 23.4249 39.5029 22.0525 39.5029 20.6028C39.5029 19.7523 39.64 18.9404 39.8946 18.1672C40.2667 17.0461 40.8934 16.041 41.716 15.2098C43.1457 13.7601 45.1433 12.8708 47.3367 12.8708C49.6477 12.8708 51.7433 13.8567 53.1533 15.4417C54.4068 16.8142 55.1705 18.6311 55.1705 20.6028Z",
    stroke: "#009FFF",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2556 20.564H44.4194",
    stroke: "#009FFF",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3374 17.7417V23.5213",
    stroke: "#009FFF",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadrons);
export default __webpack_public_path__ + "static/media/padrons.16cf67fe90549ff9ae5497fa0ede43ce.svg";
export { ForwardRef as ReactComponent };